module.exports = __webpack_public_path__ + "img/vpmr9_force_1_racing.0f5128a4.png";